var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_1846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.648 6.02364L18.4 4.77563L15.2236 1.59929L13.9756 0.35128C13.5072 -0.117093 12.7476 -0.117093 12.2792 0.35128L11.0312 1.59929L0.868566 11.7627L0.35128 12.28C0.125987 12.5045 0 12.8099 0 13.1278V17.0349V18.8142C0 19.4694 0.530626 20 1.18576 20H6.14073H6.87146C7.18939 20 7.49472 19.8733 7.71927 19.6487L8.23656 19.1314L18.4 8.96802L19.648 7.72001C20.1164 7.25164 20.1164 6.49201 19.648 6.02364ZM15.9543 7.22125L6.4935 16.6821C6.26598 16.9096 5.95694 17.0378 5.63531 17.0371L3.26379 17.0356C3.09853 17.0356 2.96439 16.9015 2.96439 16.7362V14.275C2.96439 14.009 3.07037 13.7533 3.25861 13.565L5.38111 11.4425L9.92552 6.89814L12.7787 4.04491C12.9714 3.85223 13.2849 3.85223 13.4776 4.04491L15.9551 6.5224C16.1478 6.71509 16.1478 7.02857 15.9551 7.22125H15.9543Z",
    fill: "#89A0BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_1846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModify);
export default __webpack_public_path__ + "static/media/icon_modify.47ccd1860c9cf4b937dd107f7086960e.svg";
export { ForwardRef as ReactComponent };